import { render, staticRenderFns } from "./farm-item.vue?vue&type=template&id=638e3c36&scoped=true"
import script from "./farm-item.vue?vue&type=script&lang=js"
export * from "./farm-item.vue?vue&type=script&lang=js"
import style0 from "./farm-item.vue?vue&type=style&index=0&id=638e3c36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e3c36",
  null
  
)

export default component.exports